import { render } from "./CloudAdmin.vue?vue&type=template&id=d989ef82"
import script from "./CloudAdmin.vue?vue&type=script&lang=js"
export * from "./CloudAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__